import { useCallback } from 'react';

import { getFragmentData } from '@e-socna/data-layer';
import { isDefined } from '@e-socna/utils';
import type { FragmentType } from '@e-socna/data-layer';

import { ServiceUsageCardCmp_ResolvableServiceUsage_Fragment } from '../Card/fragments/resolvable-service-usage.fragment';
import { ServiceUsageCardCmp_ServiceUsage_Fragment } from '../Card/fragments/service-usage.fragment';
import type { ServiceUsageType } from '../types/props.type';
import type { ServiceUsageCardCmp_ResolvableServiceUsage } from '../Card/fragments/resolvable-service-usage.fragment';
import type { ServiceUsageCardCmp_ServiceUsage } from '../Card/fragments/service-usage.fragment';

type O<
  // Output
  R extends boolean, // Required
  SU extends ServiceUsageType<R> | undefined, // Service Usage
> = SU extends undefined
  ? SU
  : R extends true
    ? ServiceUsageCardCmp_ResolvableServiceUsage
    : ServiceUsageCardCmp_ServiceUsage;

export const useGetServiceUsageData = () =>
  useCallback(
    <R extends boolean, SU extends ServiceUsageType<R> | undefined>(
      isResolvable: R,
      serviceUsage: SU,
    ): O<R, SU> =>
      !isDefined(serviceUsage)
        ? (serviceUsage as O<R, SU>)
        : isResolvable
          ? (getFragmentData(
              ServiceUsageCardCmp_ResolvableServiceUsage_Fragment,
              serviceUsage as FragmentType<
                typeof ServiceUsageCardCmp_ResolvableServiceUsage_Fragment
              >,
            ) as O<R, SU>)
          : (getFragmentData(
              ServiceUsageCardCmp_ServiceUsage_Fragment,
              serviceUsage as FragmentType<
                typeof ServiceUsageCardCmp_ServiceUsage_Fragment
              >,
            ) as O<R, SU>),
    [],
  );
